import { initialsOf } from './components/Avatar/Avatar';
import styles from './PersonAvatar.module.css';
import { Avatar, AvatarFallback } from './shadcn/avatar';

/**
 * A person's initials in a gold circle (design-system §5 *Avatar*), on the shadcn Avatar (AD #39): the look of the
 * §5 Avatar it replaces on the revamped screens. `role="img"` with the full name as its accessible name, and the
 * initials hidden from a screen reader, so "Jane Perera" is read rather than "J P".
 */
export function PersonAvatar({
    name,
    'data-testid': testId,
}: {
    readonly name: string;
    readonly 'data-testid'?: string;
}) {
    return (
        <Avatar aria-label={name} className={styles.avatar} data-testid={testId} role="img">
            <AvatarFallback aria-hidden="true" className={styles.initials}>
                {initialsOf(name)}
            </AvatarFallback>
        </Avatar>
    );
}
